<template>
	<div class="page-main">
		<nav-bar :border="false" :left-arrow="true" @click-left="pageBack"></nav-bar>

		<div class="form-box">
			<img src="~@/assets/ic_fresh_new_logo.png" class="logo" alt="" />
			<div class="title">绑定星礼卡</div>
			<div class="input-group">
				<input type="text" v-model="id" placeholder="请输入卡号" />
			</div>
			<div class="input-group">
				<input type="text" v-model="pin" placeholder="请输入密码" />
			</div>
			<button class="btn" @click="SendCard">绑定</button>
		</div>
	</div>
</template>

<script>
	import {
		navBar
	} from "vant";
	import {
		sendCard
	} from "@/api";
	export default {
		data() {
			return {
				qrcode: null,
				id: null,
				pin: null,
			};
		},
		methods: {
			SendCard() {
				if (!this.id) {
					this.$msg("请输入卡号");
					return;
				}
				if (!this.pin) {
					this.$msg("请输入密码");
					return;
				}
				sendCard(this.id, this.pin).then((d) => {
					if (d.data) {
						this.$msg(d.data);
					}
				});
			},
			pageBack() {
				window.history.back();
			},
		},
		components: {
			navBar,
		},
	};
</script>

<style lang="scss" scoped>
	.page-main {
		background: #f1f1f1;
		min-height: 100vh;

		::v-deep .van-nav-bar {
			background: #fff;

			.van-nav-bar__title,
			.van-nav-bar__left .van-icon {
				color: #333 !important;
				font-size: 20px;
			}
		}

		.form-box {
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
			margin: 180px 40px 0;
			padding: 160px 40px 80px;
			border-radius: 30px;
			background: #fff;
			position: relative;

			.logo {
				width: 260px;
				height: 260px;
				left: 50%;
				top: 0;
				margin-left: -130px;
				margin-top: -130px;
				border: 20px solid #fff;
				border-radius: 50%;
				position: absolute;
				box-sizing: border-box;
			}

			.title {
				margin-bottom: 60px;
				font-size: 48px;
				text-align: center;
				color: #333;
			}

			.input-group {
				background: #f7f7f7;
				margin-bottom: 40px;
				border-radius: 16px;
				overflow: hidden;
				padding: 10px;

				input {
					font-size: 32px;
					border: 0;
					height: 90px;
					padding: 0 30px;
					background: transparent;
					width: 100%;
					box-sizing: border-box;
				}
			}

			.btn {
				margin: auto;
				margin-top: 60px;
				border-radius: 44px;

				display: block;
				height: 88px;
				border: 0;
				width: 500px;
				background: #ff5a5f;
				color: #fff;
				font-weight: bold;
				box-sizing: border-box;
				font-size: 30px;
				text-align: center;
				line-height: 88px;
			}
		}
	}
</style>